/**
 * Theme-Toggle — Sonne/Mond mit weichem Crossfade.
 *
 * Klick wechselt zwischen Light und Dark. Bei Right-Click (oder per
 * Doppel-Klick auf das schon aktive Icon) kann man optional via `reset()`
 * zurück zur System-Präferenz — aktuell nicht in der UI exposed,
 * Standard-User-Flow ist „ich will Dark / ich will Light", nicht
 * „ich will dem System folgen".
 */
import { AnimatePresence, motion } from "framer-motion";
import { Moon, Sun } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import { useTheme } from "@/theme/useTheme";

export function ThemeToggle() {
  const { t } = useTranslation();
  const { theme, toggle } = useTheme();
  const label =
    theme === "dark"
      ? t("theme.switch_to_light")
      : t("theme.switch_to_dark");

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggle}
      title={label}
      aria-label={label}
      className="h-8 w-8 overflow-hidden"
    >
      <AnimatePresence mode="wait" initial={false}>
        {theme === "dark" ? (
          <motion.span
            key="moon"
            initial={{ y: 12, opacity: 0, rotate: -30 }}
            animate={{ y: 0, opacity: 1, rotate: 0 }}
            exit={{ y: -12, opacity: 0, rotate: 30 }}
            transition={{ duration: 0.18 }}
            className="inline-flex"
          >
            <Moon className="h-4 w-4" />
          </motion.span>
        ) : (
          <motion.span
            key="sun"
            initial={{ y: 12, opacity: 0, rotate: 30 }}
            animate={{ y: 0, opacity: 1, rotate: 0 }}
            exit={{ y: -12, opacity: 0, rotate: -30 }}
            transition={{ duration: 0.18 }}
            className="inline-flex"
          >
            <Sun className="h-4 w-4" />
          </motion.span>
        )}
      </AnimatePresence>
    </Button>
  );
}
